export { AggregatingSearchHeader as default } from './aggregating-search-header';
export * from './aggregating-search-header';
